import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '@shared';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { PrivateDomainGuard } from './guards/private-domain.guard';
import { DomainSettingsEditEffects } from './store/effects/domain-settings-edit.effects';
import { DomainSettingsEffects } from './store/effects/domain-settings.effects';
import { reducers } from './store/reducers';

// CONTAINERS
import { PrivateDomainAddComponent } from './containers/private-domain-add/private-domain-add.component';
import { PrivateDomainEditComponent } from './containers/private-domain-edit/private-domain-edit.component';
import { PrivateDomainComponent } from './containers/private-domain/private-domain.component';

// COMPONENTS
import { AccountDomainAddComponent } from './components/account-domain-add/account-domain-add.component';
import { PrivateDomainNotFoundComponent } from './components/private-domain-not-found/private-domain-not-found.component';
import { SectionsDomainAddComponent } from './components/sections-domain-add/sections-domain-add.component';

@NgModule({
  declarations: [
    PrivateDomainComponent,
    PrivateDomainEditComponent,
    PrivateDomainAddComponent,
    AccountDomainAddComponent,
    SectionsDomainAddComponent,
    PrivateDomainNotFoundComponent,
  ],
  providers: [PrivateDomainGuard],
  imports: [
    AutocompleteLibModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgbModule,
    StoreModule.forFeature('PrivateDomain', reducers),
    EffectsModule.forFeature([
      DomainSettingsEditEffects,
      DomainSettingsEffects,
    ]),
    SharedModule,
  ],
})
export class PrivateDomainModule {}
